import MundialRequestTask from "./MundialRequestTask";

export class BracketsTask extends MundialRequestTask {

  constructor() {
    super();
  }

  getUrl() {
    const baseUrl = this.getBaseUrl();
    return `${baseUrl}/leagues/${this.leagueId}/brackets`;
  }

  getParams() {
    const params = super.getParams();
    return {
      ...params
    };
  }
}


// WEBPACK FOOTER //
// ./src/mundial/requests/tasks/BracketsTask.ts